const STORAGE_KEY = "clientSettings";

const DEFAULT_CLIENT_SETTINGS = {
  enableCandidateAuditForClientUsers: false,
  enableBulkStartEndBookings: false,
  workHistoryYear: 2,
};

export const getClientSettings = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_CLIENT_SETTINGS;
    return { ...DEFAULT_CLIENT_SETTINGS, ...JSON.parse(raw) };
  } catch {
    return DEFAULT_CLIENT_SETTINGS;
  }
};

export const setClientSettings = (settings) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
};

export const setClientSettingsFromLogin = (responseData) => {
  setClientSettings({
    enableCandidateAuditForClientUsers: Boolean(responseData?.EnableCandidateAuditForClientUsers),
    enableBulkStartEndBookings: Boolean(responseData?.EnableBulkStartEndBookings),
    workHistoryYear: responseData?.WorkHistoryYear ?? null,
    enableReasonCodes: Boolean(responseData?.EnableReasonCodes),
  });
};